/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayIcon16Light = forwardRef('MediaUiAPlayIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3.148a1.15 1.15 0 0 1 1.742-.986l8.086 4.852a1.15 1.15 0 0 1 0 1.972l-8.086 4.852A1.15 1.15 0 0 1 3 12.852V3.148Zm1.227-.129A.15.15 0 0 0 4 3.15v9.703a.15.15 0 0 0 .227.129l8.087-4.852a.15.15 0 0 0 0-.258L4.227 3.02Z" })));
});
